module.exports = __webpack_public_path__ + "img/4.feac5280.gif";